import { BaseApi } from "../utils/request";

export interface BatchBonusClaimResp {
  status: string;
  endTime?: string | number | null;
  amount?: number | null;
  icon?: string | null;
}

export const BATCH_BONUS_UPDATED_EVENT = "batch-bonus-updated";

export const BATCH_BONUS_CLAIM_PATH = "/activity/batch-bonus-claim";

export interface BatchBonusPopupModel {
  recordId: string;
  activityId: string;
  activityName?: string;
  /** A=双卡（含充值加倍），B=单卡 */
  form: "A" | "B";
  multipleEnabled: boolean;
  amount: number;
  multipleAmount?: number | null;
  multipleQualified?: boolean;
  fromNotice?: boolean;
  multipleRatio?: number | null;
  minRecharge?: number | null;
  endTime?: string | number | null;
  serverTime?: string | number | null;
  /** 前端字段：取数时的本机时间，配合 serverTime 对时 */
  fetchedAt?: number;
  expired: boolean;
  viewed: boolean;
  claimStatus?: string | null;
  actualAmount?: number | null;
  icon?: string | null;
  floatIcon?: string | null;
  popupTitle?: string | null;
  popupBodyDirect?: string | null;
  directButtonText?: string | null;
  popupBodyMultiple?: string | null;
  directOptionTitle?: string | null;
  multipleOptionTitle?: string | null;
  multipleButtonText?: string | null;
  bottomTip?: string | null;
}

export interface BatchBonusIntentResp {
  status: string;
}

export class BatchBonusApi extends BaseApi {
  async claim(id: string) {
    return this.post<BatchBonusClaimResp, true>("/api/batch_bonus/claim", {
      id,
    });
  }

  async claimDirect(id: string, way: "DIRECT" | "MULTIPLE" = "DIRECT") {
    return this.post<BatchBonusClaimResp, true>(
      "/api/batch_bonus/claim",
      { id, way },
      { alert: false }
    );
  }

  /** 不传 id 走登录命中判定；传 id 按记录取（含已领/过期） */
  async popup(id?: string) {
    return this.post<BatchBonusPopupModel | null, true>(
      "/api/batch_bonus/popup",
      id ? { id } : {},
      { alert: false, ignore: true }
    );
  }

  async view(id: string) {
    return this.post<unknown, true>(
      "/api/batch_bonus/view",
      { id },
      { alert: false, ignore: true }
    );
  }

  async close(id: string) {
    return this.post<unknown, true>(
      "/api/batch_bonus/close",
      { id },
      { alert: false, ignore: true }
    );
  }

  /** 只标记加倍意图，充值达标后后端推事件再弹 */
  async multipleIntent(id: string) {
    return this.post<BatchBonusIntentResp, true>(
      "/api/batch_bonus/multiple_intent",
      { id },
      { alert: false }
    );
  }

  async status(id: string) {
    return this.post<BatchBonusClaimResp, true>("/api/batch_bonus/status", {
      id,
    });
  }
}

export const batchBonusApi = new BatchBonusApi();
